export default "assets/images/texture_content-58773e18.jpg";